module.exports = __webpack_public_path__ + "static/media/logoShearlyCap.e6b8d541.png";